import React from 'react';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';

// ------------------------------------------------------
// Root
/** Contains all the parts of a scroll area. */
const Root = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(ScrollAreaPrimitive.Root, props, children);
};
Root.displayName = "Root";
// ------------------------------------------------------
// Viewport
/** The viewport area of the scroll area.  */
const Viewport = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(ScrollAreaPrimitive.Viewport, props, children);
};
Viewport.displayName = "Viewport";
// ------------------------------------------------------
// Scrollbar
/** The vertical scrollbar. Add a second Scrollbar with an orientation prop to enable horizontal scrolling. */
const Scrollbar = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(ScrollAreaPrimitive.Scrollbar, props, children);
};
Scrollbar.displayName = "Scrollbar";
// ------------------------------------------------------
// Thumb
/** The thumb to be used in ScrollArea.Scrollbar. */
const Thumb = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(ScrollAreaPrimitive.Thumb, props, children);
};
Thumb.displayName = "Thumb";
// ------------------------------------------------------
// Corner
/** The corner where both vertical and horizontal scrollbars meet. */
const Corner = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(ScrollAreaPrimitive.Corner, props, children);
};
Corner.displayName = "Corner";
// Exports
Root.displayName = 'ScrollArea';
Viewport.displayName = 'Viewport';
Scrollbar.displayName = 'Scrollbar';
Thumb.displayName = 'Thumb';
Corner.displayName = 'Corner';
var ScrollArea = Object.assign(Root, {
  Viewport,
  Scrollbar,
  Thumb,
  Corner
});

export { Corner, Root, Scrollbar, Thumb, Viewport, ScrollArea as default };
